/**
 * Determines if the app is running within the fedramp environment.  For this to work, the lambda
 * that serves up the index.html must set the value 'aws-us-gov' to the window's __INITIAL_STATE__.config.awsPartition property
 */
export default () =>
  // get value everytime so e2e can inject the value
  (window as any)?.__INITIAL_STATE__?.config?.awsPartition === 'aws-us-gov';
